import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import isNumber from 'lodash/isNumber';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { selectSelectedQuantityWrapper } from '../../selectors/PdpNameSpaceSelector';
import SelectDropdown from '../SelectDropdown/SelectDropdown';
import actions from '../../actions/QuantityAction';
import * as styles from './Quantity.css';

const cx = classNames.bind(styles);

export class Quantity extends Component {
    static propTypes = {
        automationId: PropTypes.string,
        maxQuantity: PropTypes.number,
        selectedQuantity: PropTypes.number,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        query: PropTypes.object,
        fromMiniPDP: PropTypes.bool,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        automationId: '',
        maxQuantity: 25,
        selectedQuantity: 1,
        actions: {},
        query: {},
        fromMiniPDP: false,
        disabled: false,
    };

    componentDidMount() {
        const { query, fromMiniPDP } = this.props;
        if (query && query.qty) {
            this.props.actions.setSelectedQuantity(parseInt(query.qty, 10), fromMiniPDP);
        } else if (!isNumber(this.props.selectedQuantity)) {
            this.props.actions.setSelectedQuantity(1, fromMiniPDP);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            query: { qty },
            fromMiniPDP,
            actions: propsActions,
            selectedQuantity,
            maxQuantity,
        } = this.props;
        const {
            query: { qty: prevQty },
        } = prevProps;
        if (selectedQuantity !== maxQuantity && selectedQuantity > maxQuantity) {
            propsActions.setSelectedQuantity(maxQuantity > 0 ? maxQuantity : 1, fromMiniPDP);
        }
        if (qty && qty !== prevQty) {
            propsActions.setSelectedQuantity(parseInt(qty, 10), fromMiniPDP);
        }
    }

    getInitialQuantity(selectedQuantity) {
        const { query } = this.props;
        let initialQuantity;

        /* istanbul ignore if */
        if (selectedQuantity === 0) {
            initialQuantity = query && query.qty ? parseInt(query.qty, 10) : 1;
        } else {
            initialQuantity = selectedQuantity;
        }

        return initialQuantity;
    }

    setSelectedQuantity = (value) => {
        const { fromMiniPDP } = this.props;
        this.props.actions.setSelectedQuantity(parseInt(value, 10), fromMiniPDP);
    };

    render() {
        const { fromMiniPDP, disabled } = this.props;
        const quantityContainer = 'sm12 md12 lg12 xl12';
        const defaultValueRequired = false;
        const quantityData = [...Array(this.props.maxQuantity)].map((_, index) => ({
            id: index + 1,
            value: index + 1,
        }));
        const wrapperStyle = dt(['block', 'my-6', 'mx-0', '!py-0', '!px-0', 'pr-4', 'pl-0']);

        return (
            <div
                className={cx('wrapper', wrapperStyle, quantityContainer, {
                    miniPDPWrapper: fromMiniPDP,
                })}
            >
                <SelectDropdown
                    name="quantity"
                    datasource={quantityData}
                    defaultValueRequired={defaultValueRequired}
                    disabled={disabled}
                    automationId={this.props.automationId}
                    optionDisplayValue="value"
                    optionValue="id"
                    onChangeHandler={this.setSelectedQuantity}
                    value={this.getInitialQuantity(this.props.selectedQuantity)}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    selectedQuantity: selectSelectedQuantityWrapper(ownProps.fromMiniPDP)(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Quantity);
